import data from "./MainData";
import StatCard from "@/components/StatCard/StatCard";
import MainDashboard from "@/components/MainDashboard/MainDashboard";
import lodash from "lodash";

export default {
  ...data,
  components: {
    MainDashboard,
    StatCard,
    DimensionAnalysis: () =>
      import("@/components/DimensionAnalysis/DimensionAnalysis"),
    CustomersAnalysis: () => import("@/components/Customers/Customers"),
    ProductsAnalysis: () => import("@/components/Products/Products"),
  },
  computed: {
    getReportDates() {
      if (this.reportDates.length === 2) {
        let moment = require("moment");

        let datefrom = moment(this.reportDates[0], "DD-MM-YYYY");
        let dateto = moment(this.reportDates[1], "DD-MM-YYYY");

        if (moment(datefrom).isBefore(dateto) === true) {
          return this.reportDates.join(" to ");
        } else {
          this.reportDates.unshift(this.reportDates[1]);
          this.reportDates.pop();
          return this.reportDates.join(" to ");
        }
      }
    },
    datePickerIcon() {
      if (this.showDatePickers === true) {
        return "mdi-arrow-collapse";
      } else {
        return "mdi-arrow-expand";
      }
    },
    icon() {
      if (this.selectedBranch.length === this.userBranches) {
        return "mdi-close-box";
      } else if (this.selectedBranch.length !== this.userBranches) {
        return "mdi-minus-box";
      } else {
        return "mdi-checkbox-blank-outline";
      }
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectedBranch.length === this.userBranches.length) {
          this.selectedBranch = [];
        } else {
          this.selectedBranch = this.userBranches.slice();
        }
        this.updateBranch();
      });
    },
    selectedAllBranch() {
      if (this.selectAllBranch === true) {
        this.selectedBranch = [...this.userBranches];
      } else {
        this.selectedBranch = [];
      }
      this.updateBranch();
    },
    updateBranch() {
      //console.log(this.selectedBranch);
      //this.selectedBranch = [];
      this.selectedDatasets = [];

      this.selectedBranch.forEach((item) => {
        let branchIndex = this.userBranches.findIndex((i) => i === item);
        this.selectedDatasets.push(this.userDataset[branchIndex]);
      });
      //this.getSelectData();
    },
    openReport(report) {
      this.selectedReport = report;
      this.showReportsMenu = false;
    },
    updateData() {
      console.log("update");
      this.getSelectData();
      this.$refs.MainDashboard.getStatCardsData();
      this.$refs.MainDashboard.getTableData();
      this.$refs.MainDashboard.getVisitsData();
      this.$refs.CustomersAnalysis.getCustData();
    },
    showDimensionAnalysisComponent() {
      this.showDimensionAnalysis = !this.showDimensionAnalysis;
    },
    logout() {
      gapi.auth2.getAuthInstance().signOut();
      this.signedIn = false;
      this.username = "";
      this.useremail = "";
    },
    getSignedInStatus() {
      const config = {
        client_id:
          "1082735422951-k8jinf99llbujibrb32lpjeeegad5ldm.apps.googleusercontent.com",
        scope: "https://www.googleapis.com/auth/bigquery",
      };

      gapi.load("auth2", () => {
        gapi.auth2.init(config).then(() => {
          let signedIn = gapi.auth2.getAuthInstance().isSignedIn.get();

          if (signedIn === true) {
            let currentUser = gapi.auth2.getAuthInstance().currentUser.get();
            let userProfile = currentUser.getBasicProfile();
            this.username = userProfile.getName();
            this.useremail = userProfile.getEmail();
            this.userImage = userProfile.getImageUrl();
            this.getUserDataset();
          } else if (signedIn === false) {
            gapi.auth2
              .getAuthInstance()
              .signIn({ prompt: "select_account" })
              .then((res) => {
                let currentUser = gapi.auth2
                  .getAuthInstance()
                  .currentUser.get();
                let userProfile = currentUser.getBasicProfile();
                this.username = userProfile.getName();
                this.$store.dispatch(
                  "userProfileVuex/setUsername",
                  this.username
                );
                this.useremail = userProfile.getEmail();
                this.$store.dispatch(
                  "userProfileVuex/setUseremail",
                  this.useremail
                );
                this.userImage = userProfile.getImageUrl();
                this.$store.dispatch(
                  "userProfileVuex/setUserimage",
                  this.userImage
                );
                this.getUserDataset();
              });
          }
        });
      });
    },
    getUserDataset() {
      try {
        gapi.client.load("bigquery", "v2").then(() => {
          let sqlquery = `SELECT * FROM srg2-168602.jasmineusers.users 
        WHERE useremail = "${this.useremail}"`;

          let request = gapi.client.bigquery.jobs.query({
            projectId: "1082735422951",
            timeoutMs: "50000",
            query: sqlquery,
            useLegacySql: false,
          });

          request.execute((response) => {
            if (response.code === 403) {
              this.signedIn = false;
              alert(response.message);
            } else {
              this.signedIn = true;
              let datasets = response.rows[0].f[2].v;
              let areas = response.rows[0].f[3].v;
              let custgroups = response.rows[0].f[4].v;
              let nkagroups = response.rows[0].f[5].v;
              let custs = response.rows[0].f[6].v;
              let prods = response.rows[0].f[7].v;
              let branches = response.rows[0].f[8].v;
              let roles = response.rows[0].f[9].v;

              datasets.forEach((i) => {
                this.userDataset.push(i.v);
              });

              if (areas[0].v === "*") {
              } else {
                this.userAreas += " AND area IN (";
                areas.forEach((i, index) => {
                  if (index < areas.length - 1) {
                    this.userAreas += `"${i.v}",`;
                  } else {
                    this.userAreas += `"${i.v}")`;
                  }
                });
              }

              if (custgroups[0].v === "*") {
              } else {
                this.userCustGroups += " AND custgroup IN (";
                custgroups.forEach((i, index) => {
                  if (index < custgroups.length - 1) {
                    this.userCustGroups += `"${i.v}",`;
                  } else {
                    this.userCustGroups += `"${i.v}")`;
                  }
                });
              }

              if (nkagroups[0].v === "*") {
              } else if (nkagroups[0].v === "all") {
                this.userNKAGroups += "AND nkagroup IS NOT NULL";
              } else {
                this.userNKAGroups += " AND nkagroup IN (";
                nkagroups.forEach((i, index) => {
                  //this.userNKAGroups.push(i.v);
                  if (index < nkagroups.length - 1) {
                    this.userNKAGroups += `"${i.v}",`;
                  } else {
                    this.userNKAGroups += `"${i.v}")`;
                  }
                });
              }

              if (custs[0].v === "*") {
                this.userCusts += "true";
              } else {
                this.userCusts += "custno IN (";
                custs.forEach((i, index) => {
                  //this.userCusts.push(i.v);
                  if (index < custs.length - 1) {
                    this.userCusts += `"${i.v}",`;
                  } else {
                    this.userCusts += `"${i.v}")`;
                  }
                });
              }

              if (prods[0].v === "*") {
                this.userProds += "true";
              } else {
                this.userProds += "prodno IN (";
                prods.forEach((i, index) => {
                  //this.userProds.push(i.v);
                  if (index < prods.length - 1) {
                    this.userProds += `"${i.v}",`;
                  } else {
                    this.userProds += `"${i.v}")`;
                  }
                });
              }

              branches.forEach((i, index) => {
                this.userBranches.push(i.v);
              });

              /*areas.forEach((i, index) => {
                this.userAreasList.push(i.v);
              });*/

              roles.forEach((i, index) => {
                //this.userRoles.push(i.v);
                if (index < roles.length - 1) {
                  this.userRoles += `"${i.v}",`;
                } else {
                  this.userRoles += `"${i.v}"`;
                }
              });

              this.$store.dispatch(
                "userProfileVuex/setDatasets",
                this.userDataset
              );

              this.$store.dispatch("userProfileVuex/setAreas", this.userAreas);

              this.$store.dispatch(
                "userProfileVuex/setCustgroups",
                this.userCustGroups
              );

              this.$store.dispatch(
                "userProfileVuex/setNkagroups",
                this.userNKAGroups
              );

              this.$store.dispatch("userProfileVuex/setCusts", this.userCusts);

              this.$store.dispatch("userProfileVuex/setProds", this.userProds);

              this.$store.dispatch(
                "userProfileVuex/setBranches",
                this.userBranches
              );

              this.$store.dispatch("userProfileVuex/setRoles", this.userRoles);

              //this.selectedBranch.push(this.userBranches[0]);
              //this.selectedDatasets.push(this.userDataset[0]);
              //this.getSelectData();
            }
          });
        });
      } catch (err) {
        alert(err);
      }
    },
    getSelectData() {
      console.log("yay");
      let querydataset = "";

      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} `;
        }
      });

      gapi.client.load("bigquery", "v2").then(() => {
        let sqlquery = `
        WITH querydataset AS (
          ${querydataset}
        )

        SELECT CASE WHEN custgroupcat IS NULL THEN "Uncategorised" ELSE custgroupcat END AS custcat, 
          custgroup, nkagroup, prodgroupcat AS category, brand, uom,  area,  
          CASE WHEN docdate >= "${this.reportDates[0]}" 
            AND docdate <= "${this.reportDates[1]}" THEN SUM(amount) ELSE 0 END AS amt1, 
          CASE WHEN docdate >= "${this.reportDates[0]}" 
            AND docdate <= "${this.reportDates[1]}" THEN SUM(mt) ELSE 0 END AS mt1
          FROM querydataset
          WHERE 
            docdate >= "${this.reportDates[0]}" AND docdate <= "${this.reportDates[1]}" 
            ${this.userAreas}
            ${this.userCustGroups}
            ${this.userNKAGroups}
          GROUP BY custcat, custgroup, nkagroup, category, brand, uom,  area,  docdate`;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        request.execute((response) => {
          this.resultTotalRows = parseInt(response.totalRows);
          this.custcat = [];
          this.areas = [];
          this.custgroup = [];

          this.processResponse(response);
        });
      });
    },
    processResponse(response) {
      console.log(this.resultTotalRows, this.custcat.length);
      response.rows.forEach((item) => {
        this.custcat.push(item.f[0].v);
        this.custgroup.push(item.f[1].v);
        this.areas.push(item.f[6].v);
      });
      if (this.resultTotalRows > this.custcat.length) {
        let jobref = response.jobReference;
        jobref.pageToken = response.pageToken;

        this.fetchBalRows(jobref);
      } else {
        this.userAreasList = [...new Set(this.areas)];
        this.userCustCatList = lodash.uniq(this.custcat);
        //this.userCustCatList.push("99 Speedmart");
        this.userCustGroupList = [...new Set(this.custgroup)];
      }
    },
    fetchBalRows(jobref) {
      let request = gapi.client.bigquery.jobs.getQueryResults(jobref);

      request.execute((response) => {
        console.log("fetch", response);
        //back to process results and append to resultsArray
        this.processResponse(response);
      });
    },
  },
  mounted() {
    const googleapi = document.createElement("script");
    googleapi.setAttribute("src", "https://apis.google.com/js/client.js");
    document.head.appendChild(googleapi);

    const jquerymin = document.createElement("script");
    jquerymin.setAttribute(
      "src",
      "https://ajax.googleapis.com/ajax/libs/jquery/1.7.2/jquery.min.js"
    );
    document.head.appendChild(jquerymin);

    const googlejsapi = document.createElement("script");
    googlejsapi.setAttribute("type", "text/javascript");
    googlejsapi.setAttribute("src", "https://www.google.com/jsapi");
    document.head.appendChild(googlejsapi);

    const googleapi2 = document.createElement("script");
    googleapi2.setAttribute("src", "https://apis.google.com/js/api.js");
    document.head.appendChild(googleapi2);

    let moment = require("moment");

    this.reportDates.push(
      moment(new Date())
        .startOf("month")
        .format("YYYY-MM-DD")
    );

    this.reportDates.push(moment(new Date()).format("YYYY-MM-DD"));

    setTimeout(() => {
      this.getSignedInStatus();
    }, 5000);
  },
};
